import './App.css';

import { BrowserRouter as Router ,Routes,Route } from 'react-router-dom';
import PrivacyPage from './Pages/PrivacyPage';
import TodoPrivacyPage from './Pages/TodoPrivacyPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivacyPage/>}/>
        <Route path="/todo-terms" element={<TodoPrivacyPage/>}/>

        
      </Routes>
    </Router>
  );
}

export default App;
